import { sortObjectByProperty, groupByProperty } from '@/utils/helpers/ObjectSorting'
import { EmployeeResource, AssignmentResource, AddressResource, EmployeeDirectDepositRuleResource, CityResource, StateResource } from '@sigmacloud/sigma-client/dist/resources'
import { getSimpleDate } from '@/utils/helpers/FormatDate'
/**
 * Class to help extract and summarize payroll data to be imported into ProBooks
 */
export class JobData {
  id
  lines
  projectName
  weekEnding
  checkDate
  breakdown
  lastName
  firstName
  employeeId
  employeeName
  tinLast4
  isLoanout
  isUnion
  loanoutName
  feinLast4
  payeeName
  paymentNumbers
  jobTitle
  workCity
  workState
  defaultBudgetCode
  defaultFringeCode
  defaultHandlingCode
  local
  localName
  scaleRate

  payCodes
  feeCodes
  eeTaxCodes
  deductionCodes
  unionFeeCodes

  /*
  assignmentId
  type
  subtype
  code
  codeName
  hours
  amountDecimal
  visibleEmployee
  visibleClient
  creditToClient
  overtime
  factor
  taxable
  pensionable
  pensionHoursUnits
  hourlyUnitRate
  descriptionCheck
  descriptionReport
  workAddressId
  customerAccount
  customerSeries
  customerLocation
  customerSet
  customerFf1
  */

  totalAmount

  constructor (index, linesArray) {
    this.id = index
    this.clientName = linesArray[0].client_name
    this.projectName = linesArray[0].project_name
    this.lines = linesArray
    this.assignmentId = linesArray[0].assignment_id
    this.lastName = (linesArray[0].last_name || '').trim().toUpperCase()
    this.firstName = (linesArray[0].first_name || '').trim().toUpperCase()
    this.employeeId = linesArray[0].employee_id
    this.employeeName = ((this.lastName + ', ' + this.firstName) || '').trim()
    this.tinLast4 = linesArray[0].tin_last_4
    this.isLoanout = linesArray[0].is_loanout || false
    this.loanoutName = (linesArray[0].loanout_name || '').trim().toUpperCase()
    this.feinLast4 = linesArray[0].fein_last_4
    this.payeeName = (this.isLoanout ? this.loanoutName : this.lastName + ', ' + this.firstName).trim()
    this.paymentNumbers = linesArray[0].payment_numbers
    this.jobTitle = linesArray[0].job_title
    this.payPeriodStartDate = getSimpleDate(new Date(linesArray[0].pay_period_start_date), 'yyyy-mm-dd', 10)
    this.payPeriodStartDateTime = linesArray[0].pay_period_start_date
    this.payPeriodEndDate = getSimpleDate(new Date(linesArray[0].pay_period_end_date), 'yyyy-mm-dd', 10)
    this.payPeriodEndDateTime = linesArray[0].pay_period_end_date
    this.weekEnding = getSimpleDate(new Date(linesArray[0].pay_period_end_date), 'yyyy-mm-dd', 10)
    this.weekEndingTime = linesArray[0].pay_period_end_date
    this.invoiceDate = this.checkDate = getSimpleDate(new Date(linesArray[0].check_date), 'yyyy-mm-dd', 10)
    this.invoiceDateTime = this.checkDateTime = linesArray[0].check_date
    this.workCity = linesArray[0].work_city || ''
    this.workState = linesArray[0].work_state || ''
    this.defaultBudgetCode = linesArray[0].default_budget_code
    this.defaultFringeCode = linesArray[0].default_fringe_code
    this.defaultHandlingCode = linesArray[0].default_hf_code || this.defaultFringeCode
    this.local = linesArray[0].local
    this.localName = linesArray[0].local_name
    this.scaleRate = linesArray[0].scale_rate_decimal
    this.isUnion = (this.local && this.local !== 'NONE') || false

    this.payCodes = []
    this.feeCodes = []
    this.eeTaxCodes = []
    this.deductionCodes = []
    this.unionFeeCodes = []
    /*
    this.type = type
    this.subtype = subtype
    this.code = code
    this.codeName = code_name
    this.hours = hours
    this.amountDecimal = amount_decimal
    this.visibleEmployee = visible_employee
    this.visibleClient = visible_client
    this.creditToClient = credit_to_client
    this.overtime = overtime
    this.factor = factor
    this.taxable = taxable
    this.pensionable = pensionable
    this.pensionHoursUnits = pension_hours_units
    this.hourlyUnitRate = hourly_unit_rate
    this.descriptionCheck = description_check
    this.descriptionReport = description_report
    this.workAddressId = work_address_id
    this.customerAccount = customer_account
    this.customerBudgetCode = customer_budget_code
    this.customerFringeCode = customer_fringe_code
    this.customerHfCode = customer_hf_code
    this.customerSeries = customer_series
    this.customerLocation = customer_location
    this.customerSet = customer_set
    this.customerFf1 = customer_ff1
    console.log(this.breakdown)
    */

    this.breakdown = this.breakCosts()
    this.totalAmount = this.breakdown.total.toFixed(2)
  }

  // Use this to break out the below "get" methods, e.g. getTotalPay(), by account code
  getDataByCoding (method = 'getTotalPay') {
    let results = {}
    if (typeof this[method] !== 'function') {
      throw new Error('Bad function ' + method)
    }

    let linesByCode = groupByProperty(this.lines, 'account_string')
    for (const coding in linesByCode) {
      let codedGroup = new JobData(coding, linesByCode[coding])
      if (codedGroup[method]() !== '0.00') {
        // console.log(this.expandCodedLine(coding, codedGroup[method]()))
        results[coding] = this.expandCodedLine(coding, codedGroup[method]())
      }
    }
    return results
  }

  getDataByPayCode (method = 'getTotalPay') {
    let results = {}
    if (typeof this[method] !== 'function') {
      throw new Error('Bad function ' + method)
    }

    let linesByCode = groupByProperty(this.lines, 'code')
    for (const payCode in linesByCode) {
      let codedGroup = new JobData(payCode, linesByCode[payCode])
      if (codedGroup[method]() !== '0.00') {
        // console.log(linesByCode)
        // console.log(this.expandCodedLine(linesByCode[payCode][0].account_string, codedGroup[method]()))
        results[payCode] = this.expandCodedLine(linesByCode[payCode][0].account_string, codedGroup[method]())
      }
    }
    // debugger
    return results
  }

  getDataByPayCodeDetailed (method = 'getTotalPay') {
    let results = {}
    if (typeof this[method] !== 'function') {
      throw new Error('Bad function ' + method)
    }

    let linesByCode = groupByProperty(this.lines, 'code')
    for (const payCode in linesByCode) {
      let codedGroup = new JobData(payCode, linesByCode[payCode])
      if (codedGroup[method]() !== '0.00') {
        // console.log(linesByCode)
        // console.log(this.expandCodedLine(linesByCode[payCode][0].account_string, codedGroup[method]()))
        results[payCode] = this.expandCodedLineDetailed(linesByCode[payCode][0].account_string, codedGroup[method]())
      }
    }
    // debugger
    return results
  }

  getDataByCodingDetailed (method = 'getTotalPay') {
    let results = {}
    if (typeof this[method] !== 'function') {
      throw new Error('Bad function ' + method)
    }

    let linesByCode = groupByProperty(this.lines, 'account_string')
    for (const coding in linesByCode) {
      let codedGroup = new JobData(coding, linesByCode[coding])
      if (codedGroup[method]() !== '0.00') {
        // console.log(this.expandCodedLine(coding, codedGroup[method]()))
        results[coding] = this.expandCodedLine(coding, codedGroup[method]())
      }
    }
    return results
  }

  getLinesByPayCode (method = 'getTotalPayLines') {
    let results = {}
    if (typeof this[method] !== 'function') {
      throw new Error('Bad function ' + method)
    }

    let linesByCode = groupByProperty(this[method](), 'code')
    for (const payCode in linesByCode) {
      let codedGroup = new JobData(payCode, linesByCode[payCode])
      if (codedGroup[method]() !== '0.00') {
        // console.log(linesByCode)
        results[payCode] = this.expandCodedLine(linesByCode[payCode][0].account_string, codedGroup)
      }
    }
    // debugger
    return results
  }

  /*
  getTotalPayByCoding () {
    let results = {}

    let linesByCode = groupByProperty(this.lines, 'account_string')
    for (const coding in linesByCode) {
      let codedGroup = new JobData(coding, linesByCode[coding])
      if (codedGroup.getTotalPay() !== '0.00') results[coding] = codedGroup.getTotalPay()
    }
    return results
  }

  getTotalErCostByCoding () {
    let results = {}

    let linesByCode = groupByProperty(this.lines, 'account_string')
    console.log(linesByCode)
    for (const coding in linesByCode) {
      let codedGroup = new JobData(coding, linesByCode[coding])
      if (codedGroup.getTotalErCost() !== '0.00') results[coding] = codedGroup.getTotalErCost()
    }
    return results
  }

  getTaxablePayByCoding () {
    let linesByCode = groupByProperty(this.lines, 'account_string')
    let results = {}
    for (const coding in linesByCode) {
      let codedGroup = new JobData(coding, linesByCode[coding])
      if (codedGroup.getTaxablePay() !== '0.00') results[coding] = codedGroup.getTaxablePay()
    }
    return results
  }
  */

  // Basic pay
  getTotalPay () {
    return (parseFloat(this.breakdown.wages.total.amount) || 0).toFixed(2)
  }

  getTotalHours () {
    return (parseFloat(this.breakdown.wages.total.hours) || 0).toFixed(2)
  }

  // Costs + wages
  getTotalErCostAndWages () {
    return (parseFloat(this.getTotalPay()) + parseFloat(this.getTotalErFees()) + parseFloat(this.getTotalErTaxes())).toFixed(2)
  }

  // All Employer costs
  getTotalErCost () {
    return (parseFloat(this.getTotalErFees()) + parseFloat(this.getTotalErTaxes())).toFixed(2)
  }

  getTotalErCostWithoutCredits () {
    return (parseFloat(this.getTotalErFees()) + parseFloat(this.getTotalErTaxes()) - parseFloat(this.getErReturnedDeductions())).toFixed(2)
  }

  // Get more specific data
  // Taxable + nonTaxable = total pay
  getTaxablePay () {
    return (parseFloat(this.breakdown.wages.grossTaxable.amount) || 0).toFixed(2)
  }

  getNonTaxablePay () {
    return (parseFloat(this.breakdown.wages.grossNonTaxable.amount) || 0).toFixed(2)
  }

  // Straight + OT + Allowances + Other pay = total pay
  getStraightPay () {
    return (parseFloat(this.breakdown.wages.grossStraight.amount) || 0).toFixed(2)
  }

  getWagesPay () {
    return (parseFloat(this.breakdown.wages.grossWages.amount) || 0).toFixed(2)
  }

  getGrossWagesPay () {
    return this.getWagesPay()
  }

  getNetWagesPay () {
    return (parseFloat(this.getGrossWagesPay()) - parseFloat(this.getEeTotalFees())).toFixed(2)
  }

  getOvertimePay () {
    return (parseFloat(this.breakdown.wages.grossOvertime.amount) || 0).toFixed(2)
  }

  getAllowancePay () {
    return (parseFloat(this.breakdown.wages.grossAllowance.amount) || 0).toFixed(2)
  }

  getOtherPay () {
    return (parseFloat(this.breakdown.wages.grossOther.amount) || 0).toFixed(2)
  }

  // Broken out Handling/Admin/ER costs
  getTotalErFees () {
    return (parseFloat(this.breakdown.erFees.total.amount) || 0).toFixed(2)
  }

  getHandlingFees () {
    return (parseFloat(this.breakdown.erFees.admin.amount) || 0).toFixed(2)
  }

  getAcaFees () {
    return (parseFloat(this.breakdown.erFees.aca.amount) || 0).toFixed(2)
  }

  getHandlingAndAcaFees () {
    return (parseFloat(this.getHandlingFees() || 0) + parseFloat(this.getAcaFees() || 0)).toFixed(2)
  }

  getHandlingAndPostageFees () {
    return (parseFloat(this.getHandlingFees() || 0) + parseFloat(this.getAcaFees() || 0) + parseFloat(this.getPostageDelivery() || 0)).toFixed(2)
  }

  getErExceptHandlingFees () {
    return (parseFloat(this.getTotalErCost() || 0) - parseFloat(this.getHandlingFees() || 0)).toFixed(2)
  }

  getErExceptHandlingAndPostageFees () {
    return (parseFloat(this.getTotalErCost() || 0) - parseFloat(this.getHandlingFees() || 0) - parseFloat(this.getPostageDelivery() || 0)).toFixed(2)
  }

  getErExceptHandlingAndAcaAndPostageFees () {
    return (parseFloat(this.getTotalErCost() || 0) - parseFloat(this.getHandlingFees() || 0) - parseFloat(this.getAcaFees() || 0) - parseFloat(this.getPostageDelivery() || 0)).toFixed(2)
  }

  getWcFees () {
    return (parseFloat(this.breakdown.erFees.wcomp.amount) || 0).toFixed(2)
  }

  getErExceptWcFees () {
    return (parseFloat(this.getTotalErCost() || 0) - parseFloat(this.getWcFees() || 0)).toFixed(2)
  }

  getErExceptUnionFees () {
    return (parseFloat(this.getTotalErCost() || 0) - parseFloat(this.getTotalUnionBenefits() || 0)).toFixed(2)
  }

  getErBenefitFees () {
    return (parseFloat(this.breakdown.erFees.er_ben.amount || 0) /* + parseFloat(this.getTotalUnionBenefits() || 0) */).toFixed(2)
  }

  getErBenefitFeesNoUnion () {
    return (parseFloat(this.breakdown.erFees.er_ben.amount || 0) - parseFloat(this.getTotalUnionBenefits() || 0)).toFixed(2)
  }

  getErLocalTaxFees () {
    return (parseFloat(this.breakdown.erFees.er_local.amount) || 0).toFixed(2)
  }

  getTotalErTaxes () {
    return (parseFloat(this.breakdown.erTaxes.total.amount) || 0).toFixed(2)
  }

  getErFica () {
    return (parseFloat(this.getErFicaSs()) + parseFloat(this.getErFicaMedc())).toFixed(2)
  }

  getErFicaSs () {
    return (parseFloat(this.breakdown.erTaxes.ficass.amount) || 0).toFixed(2)
  }

  getErFicaMedc () {
    return (parseFloat(this.breakdown.erTaxes.ficamedc.amount) || 0).toFixed(2)
  }

  getErFuta () {
    return (parseFloat(this.breakdown.erTaxes.futa.amount) || 0).toFixed(2)
  }

  getErSuta () {
    return (parseFloat(this.breakdown.erTaxes.suta.amount) || 0).toFixed(2)
  }

  getErSdi () {
    return (parseFloat(this.breakdown.erTaxes.sdi.amount) || 0).toFixed(2)
  }

  getErSalesTax () {
    return (parseFloat(this.breakdown.erTaxes.sales_tax.amount) || 0).toFixed(2)
  }

  getErBusinessTax () {
    return (parseFloat(this.breakdown.erTaxes.business_tax.amount) || 0).toFixed(2)
  }

  getErLocalTax () {
    return (parseFloat(this.breakdown.erTaxes.er_local.amount) || 0).toFixed(2)
  }

  getErLocalAndOtherTaxes () {
    return (parseFloat(this.getErLocalTax() || 0) + parseFloat(this.getErBusinessTax() || 0) + parseFloat(this.getErSalesTax() || 0) + parseFloat(this.getErLocalTaxFees() || 0)).toFixed(2)
  }

  getPostageDelivery () {
    return (parseFloat(this.breakdown.other.postage.amount) || 0).toFixed(2)
  }

  getErInvAdj () {
    return (parseFloat(this.breakdown.other.inv_adj.amount) || 0).toFixed(2)
  }

  getErReturnedDeductions () {
    return (parseFloat(this.breakdown.other.returned_ded.amount) || 0).toFixed(2)
  }

  // EE Costs
  getEeTotalFees () {
    return (parseFloat(this.getEeTotalDeductions()) + parseFloat(this.getEeTotalTaxes())).toFixed(2)
  }

  getEeTotalDeductions () {
    return (parseFloat(this.breakdown.eeDeductions.total.amount) || 0).toFixed(2)
  }

  getEeDeductions () {
    return (parseFloat(this.breakdown.eeDeductions.deduction.amount) || 0).toFixed(2)
  }

  getGarnishment () {
    return (parseFloat(this.breakdown.eeDeductions.garnishement.amount) || 0).toFixed(2)
  }

  getEeTotalTaxes () {
    return (parseFloat(this.breakdown.eeTaxes.total.amount) || 0).toFixed(2)
  }

  getEeTotalWithholding () {
    return (parseFloat(this.breakdown.eeTaxes.fit.amount) + parseFloat(this.breakdown.eeTaxes.sit.amount) || 0).toFixed(2)
  }

  getEeFit () {
    return (parseFloat(this.breakdown.eeTaxes.fit.amount) || 0).toFixed(2)
  }

  getEeSit () {
    return (parseFloat(this.breakdown.eeTaxes.sit.amount) || 0).toFixed(2)
  }

  getEeFica () {
    return (parseFloat(this.breakdown.eeTaxes.ficass.amount) || 0).toFixed(2)
  }

  getEeMedc () {
    return (parseFloat(this.breakdown.eeTaxes.ficamedc.amount) || 0).toFixed(2)
  }

  getEeSdi () {
    return (parseFloat(this.breakdown.eeTaxes.sdi.amount) || 0).toFixed(2)
  }

  getEeLocal () {
    return (parseFloat(this.breakdown.eeTaxes.ee_local.amount) || 0).toFixed(2)
  }

  getEeBusinessTax () {
    return (parseFloat(this.breakdown.eeTaxes.business_tax.amount) || 0).toFixed(2)
  }

  getWorkDays () {
    return (parseInt(this.breakdown.daysWorked) || 0)
  }

  getPensionablePay () {
    return (parseFloat(this.breakdown.wages.pensionable.amount) || 0).toFixed(2)
  }

  getPensionableHours () {
    return (parseFloat(this.breakdown.wages.pensionable.hours) || 0).toFixed(2)
  }

  getTotalUnionBenefits () {
    return (parseFloat(this.breakdown.unionBenefits.total.amount) || 0).toFixed(2)
  }

  getUnionBenefit (codeName) {
    if (!codeName || typeof this.breakdown.unionBenefits[codeName] === 'undefined') return '0.00'
    else return (parseFloat(this.breakdown.unionBenefits[codeName].amount) || 0).toFixed(2)
  }

  getDeduction (codeName) {
    if (!codeName || typeof this.breakdown.eeDeductions.deduction[codeName] === 'undefined') return '0.00'
    else return (parseFloat(this.breakdown.eeDeductions.deduction[codeName].amount) || 0).toFixed(2)
  }

  getJobTitle () {
    return this.jobTitle
  }

  // Return Lines instead of amounts/hours
  getTotalPayLines () {
    return this.breakdown.wages.total.lines
  }

  getTotalEeTaxLines () {
    return this.breakdown.eeTaxes.total.lines
  }

  getTotalDeductionLines () {
    return this.breakdown.eeDeductions.total.lines
  }

  getTotalUnionBenefitLines () {
    return this.breakdown.unionBenefits.total.lines
  }

  // Splits out lines into categories
  breakCosts (lines) {
    if (!lines && !this.lines) return null
    const payLines = lines || this.lines
    const payData = {
      daysWorked: 0,
      total: 0,
      wages: { total: { amount: 0, hours: 0, lines: [] }, grossWages: { amount: 0, hours: 0, lines: [] }, grossStraight: { amount: 0, hours: 0, lines: [] }, grossOvertime: { amount: 0, hours: 0, lines: [] }, grossTaxable: { amount: 0, hours: 0, lines: [] }, grossNonTaxable: { amount: 0, hours: 0, lines: [] }, grossAllowance: { amount: 0, hours: 0, lines: [] }, grossOther: { amount: 0, hours: 0, lines: [] }, pensionable: { amount: 0, hours: 0, lines: [] } },
      erTaxes: { total: { amount: 0, lines: [] }, ficass: { amount: 0, lines: [] }, ficamedc: { amount: 0, lines: [] }, futa: { amount: 0, lines: [] }, suta: { amount: 0, lines: [] }, sdi: { amount: 0, lines: [] }, sales_tax: { amount: 0, lines: [] }, business_tax: { amount: 0, lines: [] }, er_local: { amount: 0, lines: [] } },
      erFees: { total: { amount: 0, lines: [] }, wcomp: { amount: 0, lines: [] }, er_ben: { amount: 0, lines: [] }, admin: { amount: 0, lines: [] }, aca: { amount: 0, lines: [] }, er_local: { amount: 0, lines: [] } },
      eeTaxes: {
        total: {
          amount: 0,
          lines: []
        },
        fit: {
          amount: 0,
          lines: []
        },
        sit: {
          amount: 0,
          lines: []
        },
        ficass: {
          amount: 0,
          lines: []
        },
        ficamedc: {
          amount: 0,
          lines: []
        },
        sdi: {
          amount: 0,
          lines: []
        },
        deduction: {
          amount: 0,
          lines: []
        },
        ee_local: {
          amount: 0,
          lines: []
        },
        business_tax: {
          amount: 0,
          lines: []
        }
      },
      eeDeductions: { total: { amount: 0, lines: [] }, deduction: { amount: 0, lines: [] }, taxes: { amount: 0, lines: [] }, garnishment: { amount: 0, lines: [] } },
      other: { total: { amount: 0, lines: [] }, postage: { amount: 0, lines: [] }, inv_adj: { amount: 0, lines: [] }, returned_ded: { amount: 0, lines: [] } },
      unionBenefits: { total: { amount: 0, lines: [] } }
    }

    let data = Object.assign({}, payData)

    // payrollData.forEach((line) => {
    for (const i in payLines) {
      let line = payLines[i]
      if (!line || !line.type) {
        // console.log('No line type', line)
        // console.log(line)
        continue
      }

      if (!this.defaultBudgetCode && line.customer_budget_code) this.defaultBudgetCode = line.customer_budget_code
      if (!this.defaultFringeCode && line.customer_fringe_code) this.defaultFringeCode = line.customer_fringe_code
      if (!this.defaultHandlingCode && line.customer_hf_code) this.defaultHandlingCode = line.customer_hf_code

      // Go through each line one by one. Less efficient, but easier to read than mass filters
      switch (line.type.toLowerCase()) {
        // Type for just days worked
        case 'days':
          data.daysWorked = parseInt(line.amount_decimal)
          break

        // Type for pay
        case 'pay':
          // All lines
          line.customer_account = line.customer_budget_code || this.defaultBudgetCode
          data.total += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.wages.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.wages.total.hours += line.hours ? parseFloat(line.hours) : 0
          data.wages.total.lines.push(line)
          this.payCodes.push(line.code_name)

          // Break out for taxable/non-taxable
          if (line.taxable === true) {
            data.wages.grossTaxable.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossTaxable.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossTaxable.lines.push(line)
          } else {
            data.wages.grossNonTaxable.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossNonTaxable.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossNonTaxable.lines.push(line)
          }

          // Break out for wages (straight+ OT)/allowance/other
          if (line.subtype.toLowerCase() === 'allowance') {
            data.wages.grossAllowance.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossAllowance.lines.push(line)
          } else if (line.overtime === true || line.factor > 1) {
            data.wages.grossWages.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossWages.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossWages.lines.push(line)
            data.wages.grossOvertime.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossOvertime.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossOvertime.lines.push(line)
          } else if (parseFloat(line.factor) === 1) {
            data.wages.grossWages.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossWages.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossWages.lines.push(line)
            data.wages.grossStraight.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossStraight.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossStraight.lines.push(line)
          } else {
            data.wages.grossOther.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.grossOther.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.grossOther.lines.push(line)
          }

          // Pensionable Hours
          if (line.pensionable) {
            data.wages.pensionable.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
            data.wages.pensionable.hours += line.hours ? parseFloat(line.hours) : 0
            data.wages.pensionable.lines.push(line)
          }
          break

        // Type for ER taxes
        case 'ertax':
          if (line.visible_client === false) {
            console.log('ER not visible ' + line.type + line.subtype)
            // continue
          }

          line.customer_account = line.customer_fringe_code || this.defaultFringeCode
          data.total += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.erTaxes.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.erTaxes.total.lines.push(line)

          switch (line.subtype.toLowerCase()) {
            case 'ficass':
              data.erTaxes.ficass.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.ficass.lines.push(line)
              break

            case 'ficamed':
              data.erTaxes.ficamedc.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.ficamedc.lines.push(line)
              break

            case 'futa':
              data.erTaxes.futa.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.futa.lines.push(line)
              break

            case 'suta':
              data.erTaxes.suta.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.suta.lines.push(line)
              break

            case 'sdi':
              data.erTaxes.sdi.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.sdi.lines.push(line)
              break

            case 'othertax':
              data.erTaxes.business_tax.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.business_tax.lines.push(line)
              break

            case 'sales_tax':
              data.erTaxes.sales_tax.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.sales_tax.lines.push(line)
              break

            /*
            case 'other':
              data.fica.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.fica.lines.push(line)
              break

            case 'inv_adj':
              data.inv_adj.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.inv_adj.lines.push(line)
              break

            case 'returned_ded':
              data.returned_ded.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.returned_ded.lines.push(line)
              break
            */

            case 'unknowntax':
            default:
              data.erTaxes.er_local.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erTaxes.er_local.lines.push(line)
              // console.log('Unknown tax type', line.type)
          }
          break

        // Type for ER fees
        case 'erfee':
          if (line.visible_client === false) {
            console.log('ER not visible ' + line.type + line.subtype)
            // continue
          }

          line.customer_account = line.customer_fringe_code || this.defaultFringeCode
          data.total += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.erFees.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.erFees.total.lines.push(line)
          this.feeCodes.push(line.code_name)

          switch (line.subtype.toLowerCase()) {
            case 'administrativefee':
              // Handle those clients that have a separate Handling fee
              line.customer_account = line.customer_hf_code || this.defaultHandlingCode || line.customer_fringe_code || this.defaultFringeCode

              if (line.description_report === 'Postage') {
                data.other.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.other.total.lines.push(line)
                data.other.postage.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.other.postage.lines.push(line)
              } else if (line.code === 'ACA') {
                // data.erFees.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                // data.erFees.total.lines.push(line)
                data.erFees.aca.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.erFees.aca.lines.push(line)
              } else {
                data.erFees.admin.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.erFees.admin.lines.push(line)
              }
              break

            case 'wcfee':
              data.erFees.wcomp.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erFees.wcomp.lines.push(line)
              break

            case 'eepen':
            case 'eemed':
            case 'med':
            case 'unionbenefit':
              data.erFees.er_ben.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erFees.er_ben.lines.push(line)

              // Add to collection of fees
              this.unionFeeCodes.push(line.code_name)

              // Keep track of benefits for union reporting
              data.unionBenefits.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.unionBenefits.total.lines.push(line)

              if (!data.unionBenefits[line.code_name] || typeof data.unionBenefits[line.code_name] === 'undefined') data.unionBenefits[line.code_name] = { amount: 0, lines: [] }
              data.unionBenefits[line.code_name].amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.unionBenefits[line.code_name].lines.push(line)

              break

            case 'post':
            case 'del':
              data.other.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.other.total.lines.push(line)
              data.other.postage.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.other.postage.lines.push(line)
              break

            case 'otherfee':
              if (line.credit_to_client === true) {
                // Should be a negative amount.  Since we are
                // Giving back to client so need to invert add add as a fee and as a credit
                let invertedLine = Object.assign({}, line)
                invertedLine.amount_decimal = parseFloat(invertedLine.amount_decimal || 0) * -1

                data.erFees.er_ben.amount += invertedLine.amount_decimal ? parseFloat(invertedLine.amount_decimal) : 0
                data.erFees.er_ben.lines.push(invertedLine)

                // Now add credit and...
                data.other.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.other.total.lines.push(line)
                data.other.returned_ded.amount += parseFloat(line.amount_decimal)
                data.other.returned_ded.lines.push(line)

                /*
                // ... reduce total invoice
                data.total += line.amount_decimal
                data.erFees.total.amount += line.amount_decimal
                data.erFees.total.lines.push(line)
                */
              } else {
                data.erFees.er_ben.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
                data.erFees.er_ben.lines.push(line)
              }

              break

            default:
              data.erFees.er_ben.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.erFees.er_ben.lines.push(line)
              // console.log('Unknown fee type', line.code_name)
          }
          break

        // Type of EE Non-Tax Deductions
        case 'deduction':
          line.customer_account = line.customer_fringe_code || this.defaultFringeCode
          data.eeDeductions.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeDeductions.total.lines.push(line)
          data.eeDeductions.deduction.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeDeductions.deduction.lines.push(line)
          this.deductionCodes.push(line.code_name)

          if (line.credit_to_client === true) {
            // Give back to client so need to invert
            let invertedLine = Object.assign({}, line)
            invertedLine.amount_decimal = parseFloat(invertedLine.amount_decimal || 0) * -1

            data.other.total.amount += invertedLine.amount_decimal
            data.other.total.lines.push(invertedLine)
            data.other.returned_ded.amount += invertedLine.amount_decimal
            data.other.returned_ded.lines.push(invertedLine)

            // reduce total invoice
            data.total += invertedLine.amount_decimal
            data.erFees.total.amount += invertedLine.amount_decimal
            data.erFees.total.lines.push(invertedLine)
          }
          break

        case 'garnishment':
          line.customer_account = line.customer_fringe_code || this.defaultFringeCode
          data.eeDeductions.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeDeductions.total.lines.push(line)
          data.eeDeductions.garnishment.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeDeductions.garnishment.lines.push(line)
          break

        // Type of EE Tax Deductions
        case 'eetax':
          if (line.visible_employee === false) {
            // console.log('EE not visible ' + line.type + line.subtype)
            continue
          }

          line.customer_account = line.customer_fringe_code || this.defaultFringeCode
          // data.total += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeTaxes.total.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
          data.eeTaxes.total.lines.push(line)
          this.eeTaxCodes.push(line.code_name)

          switch (line.subtype.toLowerCase()) {
            case 'fit':
              data.eeTaxes.fit.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.fit.lines.push(line)
              break

            case 'sit':
              data.eeTaxes.sit.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.sit.lines.push(line)
              break

            case 'ficass':
              data.eeTaxes.ficass.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.ficass.lines.push(line)
              break

            case 'ficamed':
              data.eeTaxes.ficamedc.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.ficamedc.lines.push(line)
              break

            case 'sdi':
              data.eeTaxes.sdi.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.sdi.lines.push(line)
              break

            case 'othertax':
              data.eeTaxes.business_tax.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.business_tax.lines.push(line)
              break

            case 'deduction':
              data.eeTaxes.deduction.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.deduction.lines.push(line)
              if (line.credit_to_client === true) {
                // Give back to client so need to invert
                let invertedLine = Object.assign({}, line)
                invertedLine.amount_decimal = parseFloat(invertedLine.amount_decimal || 0) * -1

                data.other.total.amount += invertedLine.amount_decimal
                data.other.total.lines.push(invertedLine)
                data.other.returned_ded.amount += invertedLine.amount_decimal
                data.other.returned_ded.lines.push(invertedLine)
                // reduce total invoice and fringe so need to invert
                data.total += invertedLine.amount_decimal
                data.erFees.total.amount += invertedLine.amount_decimal
                data.erFees.total.lines.push(invertedLine)
              }
              break

            case 'unknowntax':
              data.eeTaxes.ee_local.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.ee_local.lines.push(line)
              break

            default:
              // console.log('Unknown eeTax', line)
              data.eeTaxes.ee_local.amount += line.amount_decimal ? parseFloat(line.amount_decimal) : 0
              data.eeTaxes.ee_local.lines.push(line)
          }
          break

        default:
          // console.log('Unknown line type', line.type)
      }
    }
    return data
  }

  /**
   * Currently data coming from sigma query is making an account strig that is in the following format.  This function puts that info into an object that is easier to read
   * PROJECTID-ASSIGNMENTID-ACCOUNT-SERIES-LOCATION-SET-FF1
   */
  expandCodedLine (coding, data) {
    if (!coding || !data) return null

    const codeArray = coding.split('|')
    let dataObject

    // Need to handle use case of sending just an amount and new functionality to send a detailed object
    if (typeof data === 'object') {
      dataObject = data
    } else {
      dataObject = {
        amount: data
      }
    }

    // Build out data object
    // CONCAT(PROJ.id, '|', ASS.id, '|', LINES.customer_budget_code, '|', LINES.customer_fringe_code, '|', LINES.customer_hf_code, '|', LINES.customer_series, '|', LINES.customer_location, '|', LINES.customer_set, '|', LINES.customer_ff1) AS account_string,
    dataObject.account_string = coding
    dataObject.project = codeArray[0]
    dataObject.assignment = codeArray[1]
    dataObject.account = codeArray[2]
    dataObject.fringe = codeArray[3]
    dataObject.hf = codeArray[4]
    dataObject.series = codeArray[5]
    dataObject.location = codeArray[6]
    dataObject.set = codeArray[7]
    dataObject.ff1 = codeArray[8]
    dataObject.ff2 = codeArray[9]
    dataObject.isLoanout = this.isLoanout
    dataObject.isUnion = this.isUnion
    dataObject.workCity = this.workCity
    dataObject.workState = this.workState
    dataObject.lastName = this.lastName
    dataObject.firstName = this.firstName
    dataObject.employeeName = this.employeeName
    dataObject.loanoutName = this.loanoutName
    dataObject.payeeName = this.payeeName
    dataObject.jobTitle = this.jobTitle
    dataObject.weekEnding = this.weekEnding
    dataObject.weekEndingTime = this.weekEndingTime
    dataObject.tinLast4 = this.tinLast4
    dataObject.feinLast4 = this.feinLast4
    dataObject.checkDate = this.checkDate

    return dataObject
  }

  expandCodedLineDetailed (coding, amount, lines) {
    if (!coding || !amount) return null
    const codeArray = coding.split('|')
    let data = Object.assign({}, this)

    data.project = codeArray[0]
    data.assignment = codeArray[1]
    data.account = codeArray[2]
    data.series = codeArray[3]
    data.location = codeArray[4]
    data.set = codeArray[5]
    data.ff1 = codeArray[6]
    return data
    /*
    return {
      project: codeArray[0],
      assignment: codeArray[1],
      account: codeArray[2],
      series: codeArray[3],
      location: codeArray[4],
      set: codeArray[5],
      ff1: codeArray[6],
      isLoanout: this.isLoanout,
      workCity: this.workCity,
      workState: this.workState,
      lastName: this.lastName,
      firstName: this.firstName,
      employeeName: this.employeeName,
      loanoutName: this.loanoutName,
      payeeName: this.payeeName,
      jobTitle: this.jobTitle,
      weekEnding: this.weekEnding,
      weekEndingTime: this.weekEndingTime,
      tinLast4: this.tinLast4,
      feinLast4: this.feinLast4,
      checkDate: this.checkDate,
      amount
    }
    */
  }
}

export class PayrollInvoiceData {
  payrollBatchData
  payrollId
  transactionStatus
  transactionDescription
  timePosted
  payrollNumber
  payrollDescription
  payPeriodStartDate
  payPeriodEndDate
  invoiceDate
  invoiceDateTime
  weekEnding
  weekEndingTime
  clientId
  clientNumber
  clientName
  projectId
  projectName
  projectJobNumber
  contactName
  projectStartDate
  projectEndDate
  preProductionStartDate
  productionStartDate
  postProductionStartDate
  industry
  productionType
  dgaSignatoryNumber
  sagSignatoryNumber
  wgaSignatoryNumber
  mpiphpEmployerId
  mpiphpPictureId
  mpiphpProjectType
  mpiphpContributionLevel
  sagProjectId
  contractTypeId
  format

  assignmentsData
  assignmentIds
  employeeIds
  unionLocals
  payCodes
  feeCodes
  eeTaxCodes
  deductionCodes
  unionFeeCodes
  totalInvoiceAmount
  totalHours
  totalErCostAndWages
  totalErCost
  totalPay
  taxablePay
  nonTaxablePay
  straightPay
  wagesPay
  overtimePay
  allowancePay
  otherPay
  totalErFees
  handlingFees
  erExceptHandlingFees
  erExceptHandlingAndPostageFees
  wcFees
  erBenefitFees
  erLocalTaxFees
  totalErTaxes
  erFica
  erFicaSs
  erFicaMedc
  erFuta
  erSuta
  erSdi
  erSalesTax
  erBusinessTax
  erLocalTax
  localAndOtherTaxes
  postageDelivery
  erInvAdj
  erReturnedDeductions
  eeTotalFees
  eeTotalDeductions
  eeTotalTaxes
  eeTotalWithholding
  eeFit
  eeSit
  eeFica
  eeMedc
  eeSdi
  eeLocal
  eeBusinessTax
  workDays
  pensionablePay
  pensionableHours
  totalUnionBenefits
  employeeYTD

  constructor (payrollBatchData) {
    if (!Array.isArray(payrollBatchData)) return this
    this.payrollBatchData = payrollBatchData
    this.payrollId = [ ...new Set(payrollBatchData.map((line) => line.payroll_id)) ].join(', ')
    this.transactionStatus = payrollBatchData[0].transaction_status
    this.transactionDescription = payrollBatchData[0].transaction_description
    this.timePosted = payrollBatchData[0].time_posted
    this.payrollNumber = [ ...new Set(payrollBatchData.map((line) => line.doc_number)) ].join(', ')
    this.payrollDescription = payrollBatchData[0].transaction_description
    this.payPeriodStartDate = getSimpleDate(new Date([ ...new Set(payrollBatchData.map((line) => line.pay_period_start_date)) ].sort()[0]), 'yyyy-mm-dd', 10)
    this.payPeriodEndDate = getSimpleDate(new Date([ ...new Set(payrollBatchData.map((line) => line.pay_period_end_date)) ].reverse()[0]), 'yyyy-mm-dd', 10)
    this.invoiceDate = getSimpleDate(new Date(payrollBatchData[0].check_date), 'yyyy-mm-dd', 10)
    this.invoiceDateTime = payrollBatchData[0].check_date
    this.weekEnding = getSimpleDate(new Date(payrollBatchData[0].pay_period_end_date), 'yyyy-mm-dd', 10)
    this.weekEndingTime = payrollBatchData[0].pay_period_end_date
    this.clientId = payrollBatchData[0].client_id
    this.clientNumber = payrollBatchData[0].client_number
    this.clientName = payrollBatchData[0].client_name
    this.projectId = payrollBatchData[0].project_id
    // [ ...new Set(payrollBatchData.map((line) => line.project_id)) ].join(', ')
    this.projectName = payrollBatchData[0].project_name
    this.projectJobNumber = payrollBatchData[0].commercial_job_number || ''
    this.contactName = payrollBatchData[0].contact_name
    // this.contactEmail = payrollBatchData[0].contact_email
    this.projectStartDate = payrollBatchData[0].project_start_date
    this.projectEndDate = payrollBatchData[0].project_end_date
    this.preProductionStartDate = payrollBatchData[0].pre_production_start_date
    this.productionStartDate = payrollBatchData[0].production_start_date
    this.postProductionStartDate = payrollBatchData[0].post_production_start_date
    this.industry = payrollBatchData[0].industry
    this.productionType = payrollBatchData[0].production_type
    this.dgaSignatoryNumber = payrollBatchData[0].dga_signatory_number
    this.sagSignatoryNumber = payrollBatchData[0].sag_signatory_number
    this.wgaSignatoryNumber = payrollBatchData[0].wga_signatory_number
    this.mpiphpEmployerId = payrollBatchData[0].mpiphp_employer_id
    this.mpiphpPictureId = payrollBatchData[0].mpiphp_picture_id
    this.mpiphpProjectType = payrollBatchData[0].mpiphp_project_type
    this.mpiphpContributionLevel = payrollBatchData[0].mpiphp_contribution_level
    this.sagProjectId = payrollBatchData[0].sag_project_id
    this.contractTypeId = payrollBatchData[0].contract_type_id
    this.format = payrollBatchData[0].format
    this.assignmentsData = []

    let runningTotal = 0
    this.totalHours =
    this.totalErCostAndWages =
    this.totalErCost =
    this.totalPay =
    this.taxablePay =
    this.nonTaxablePay =
    this.straightPay =
    this.wagesPay =
    this.overtimePay =
    this.allowancePay =
    this.otherPay =
    this.totalErFees =
    this.handlingFees =
    this.erExceptHandlingFees =
    this.erExceptHandlingAndPostageFees =
    this.wcFees =
    this.erBenefitFees =
    this.erLocalTaxFees =
    this.totalErTaxes =
    this.erFica =
    this.erFicaSs =
    this.erFicaMedc =
    this.erFuta =
    this.erSuta =
    this.erSdi =
    this.erSalesTax =
    this.erBusinessTax =
    this.erLocalTax =
    this.localAndOtherTaxes =
    this.postageDelivery =
    this.erInvAdj =
    this.erReturnedDeductions =
    this.eeTotalFees =
    this.eeTotalDeductions =
    this.eeTotalTaxes =
    this.eeTotalWithholding =
    this.eeFit =
    this.eeSit =
    this.eeFica =
    this.eeMedc =
    this.eeSdi =
    this.eeLocal =
    this.eeBusinessTax =
    this.workDays =
    this.pensionablePay =
    this.pensionableHours =
    this.totalUnionBenefits = 0

    for (const i in groupByProperty(payrollBatchData, 'assignment_id')) {
      let data = groupByProperty(payrollBatchData, 'assignment_id')[i]
      let parsedData = new JobData(i, data)
      this.assignmentsData.push(parsedData)
      runningTotal += parseFloat(parsedData.totalAmount) || 0
      this.totalPay += parseFloat(parsedData.getTotalPay()) || 0
      this.totalHours += parseFloat(parsedData.getTotalHours()) || 0
      this.totalErCostAndWages += parseFloat(parsedData.getTotalErCostAndWages()) || 0
      this.totalErCost += parseFloat(parsedData.getTotalErCost()) || 0
      this.taxablePay += parseFloat(parsedData.getTaxablePay()) || 0
      this.nonTaxablePay += parseFloat(parsedData.getNonTaxablePay()) || 0
      this.straightPay += parseFloat(parsedData.getStraightPay()) || 0
      this.wagesPay += parseFloat(parsedData.getWagesPay()) || 0
      this.overtimePay += parseFloat(parsedData.getOvertimePay()) || 0
      this.allowancePay += parseFloat(parsedData.getAllowancePay()) || 0
      this.otherPay += parseFloat(parsedData.getOtherPay()) || 0
      this.totalErFees += parseFloat(parsedData.getTotalErFees()) || 0
      this.handlingFees += parseFloat(parsedData.getHandlingFees()) || 0
      this.acaFees += parseFloat(parsedData.getAcaFees()) || 0
      this.erExceptHandlingFees += parseFloat(parsedData.getErExceptHandlingFees()) || 0
      this.erExceptHandlingAndPostageFees += parseFloat(parsedData.getErExceptHandlingAndPostageFees()) || 0
      this.erExceptHandlingAndPostageFees += parseFloat(parsedData.getErExceptHandlingAndPostageFees()) || 0
      this.wcFees += parseFloat(parsedData.getWcFees()) || 0
      this.erBenefitFees += parseFloat(parsedData.getErBenefitFees()) || 0
      this.erLocalTaxFees += parseFloat(parsedData.getErLocalTaxFees()) || 0
      this.totalErTaxes += parseFloat(parsedData.getTotalErTaxes()) || 0
      this.erFica += parseFloat(parsedData.getErFica()) || 0
      this.erFicaSs += parseFloat(parsedData.getErFicaSs()) || 0
      this.erFicaMedc += parseFloat(parsedData.getErFicaMedc()) || 0
      this.erFuta += parseFloat(parsedData.getErFuta()) || 0
      this.erSuta += parseFloat(parsedData.getErSuta()) || 0
      this.erSdi += parseFloat(parsedData.getErSdi()) || 0
      this.erSalesTax += parseFloat(parsedData.getErSalesTax()) || 0
      this.erBusinessTax += parseFloat(parsedData.getErBusinessTax()) || 0
      this.erLocalTax += parseFloat(parsedData.getErLocalTax()) || 0
      this.localAndOtherTaxes += parseFloat(parsedData.getErLocalAndOtherTaxes()) || 0
      this.postageDelivery += parseFloat(parsedData.getPostageDelivery()) || 0
      this.erInvAdj += parseFloat(parsedData.getErInvAdj()) || 0
      this.erReturnedDeductions += parseFloat(parsedData.getErReturnedDeductions()) || 0
      this.eeTotalFees += parseFloat(parsedData.getEeTotalFees()) || 0
      this.eeTotalDeductions += parseFloat(parsedData.getEeTotalDeductions()) || 0
      this.eeTotalTaxes += parseFloat(parsedData.getEeTotalTaxes()) || 0
      this.eeTotalWithholding += parseFloat(parsedData.getEeTotalWithholding()) || 0
      this.eeFit += parseFloat(parsedData.getEeFit()) || 0
      this.eeSit += parseFloat(parsedData.getEeSit()) || 0
      this.eeFica += parseFloat(parsedData.getEeFica()) || 0
      this.eeMedc += parseFloat(parsedData.getEeMedc()) || 0
      this.eeSdi += parseFloat(parsedData.getEeSdi()) || 0
      this.eeLocal += parseFloat(parsedData.getEeLocal()) || 0
      this.eeBusinessTax += parseFloat(parsedData.getEeBusinessTax()) || 0
      this.eeGarnishment += parseFloat(parsedData.getEeBusinessTax()) || 0
      this.workDays += parseFloat(parsedData.getWorkDays()) || 0
      this.pensionablePay += parseFloat(parsedData.getPensionablePay()) || 0
      this.pensionableHours += parseFloat(parsedData.getPensionableHours()) || 0
      this.totalUnionBenefits += parseFloat(parsedData.getTotalUnionBenefits()) || 0
    }

    this.grossWagesPay = this.wagesPay
    this.netWagesPay = this.wagesPay - this.eeTotalFees
    this.assignmentIds = []
    this.employeeIds = []
    this.unionLocals = []
    this.payCodes = []
    this.feeCodes = []
    this.eeTaxCodes = []
    this.deductionCodes = []
    this.unionFeeCodes = []

    // Populate unique Assignment, Employee IDs and Union Codes
    this.assignmentsData.forEach((data) => {
      this.assignmentIds.push(data.assignmentId)
      this.employeeIds.push(data.employeeId)
      if (data.localName && data.localName !== 'NONE') this.unionLocals.push(data.local)
      if (data.payCodes && data.payCodes.length > 0) {
        data.payCodes.forEach((codeName) => {
          if (!this.payCodes.includes(codeName)) this.payCodes.push(codeName)
        })
      }
      if (data.feeCodes && data.feeCodes.length > 0) {
        data.feeCodes.forEach((codeName) => {
          if (!this.feeCodes.includes(codeName)) this.feeCodes.push(codeName)
        })
      }
      if (data.eeTaxCodes && data.eeTaxCodes.length > 0) {
        data.eeTaxCodes.forEach((codeName) => {
          if (!this.eeTaxCodes.includes(codeName)) this.eeTaxCodes.push(codeName)
        })
      }
      if (data.deductionCodes && data.deductionCodes.length > 0) {
        data.deductionCodes.forEach((codeName) => {
          if (!this.deductionCodes.includes(codeName)) this.deductionCodes.push(codeName)
        })
      }
      if (data.unionFeeCodes && data.unionFeeCodes.length > 0) {
        data.unionFeeCodes.forEach((codeName) => {
          if (!this.unionFeeCodes.includes(codeName)) this.unionFeeCodes.push(codeName)
        })
      }
    })
    this.totalInvoiceAmount = runningTotal.toFixed(2)
  }

  async addEmployeeYTDData (data) {
    this.employeeYTD = data
    /*
    let instance = this.$store.getters.getActiveInstance
    let url = this.queryServer
    options.instanceUrl = (instance.url.endsWith('/') ? instance.url.slice(0, -1) : instance.url)
    options.jwt = instance.token
    const queryString = '?' + Object.keys(options).map(key => key + '=' + options[key]).join('&')

    let postdata = {
      selectedCodes: {
        check_date_start = '2022-01-01',
        check_date_end = '2022-12-31',
        employee_id = this.employeeIds
      },
      statusTypes: [ 'POSTED' ],
      transactionTypes: [ 'EEYTD' ],
      reportCurrencyFactor: 1,
    }

    const response = await Vue.http.post(url + reportTranslation[report] + queryString, postdata)
    if (response.status !== 200 || !response.data) {
      return false
    } else {
      return response.data
    }
    */
  }

  generatePayrollInvoiceData () {
    let results = []

    if (this.totalPay && parseFloat(this.totalPay) !== 0) results.push({ 'description': 'Gross Wages', 'amount': this.totalPay })
    if (this.handlingFees && parseFloat(this.handlingFees) !== 0) results.push({ 'description': 'Administration Fees', 'amount': this.handlingFees })
    if (this.erFicaSs && parseFloat(this.erFicaSs) !== 0) results.push({ 'description': 'Social Security Tax', 'amount': this.erFicaSs })
    if (this.erFicaMedc && parseFloat(this.erFicaMedc) !== 0) results.push({ 'description': 'Medicare Tax', 'amount': this.erFicaMedc })
    if (this.erFuta && parseFloat(this.erFuta) !== 0) results.push({ 'description': 'Federal Unemployment Tax', 'amount': this.erFuta })
    if (this.erSuta && parseFloat(this.erSuta) !== 0) results.push({ 'description': 'State Unemployment Tax', 'amount': this.erSuta })
    if (this.erSdi && parseFloat(this.erSdi) !== 0) results.push({ 'description': 'State Disability Tax', 'amount': this.erSdi })
    if (this.wcFees && parseFloat(this.wcFees) !== 0) results.push({ 'description': 'Workers Comp Coverage & Risk Management', 'amount': this.wcFees })
    if (this.erBenefitFees && parseFloat(this.erBenefitFees) !== 0) results.push({ 'description': 'Client Billing for Employee Benefits', 'amount': this.erBenefitFees })
    if (this.localAndOtherTaxes && parseFloat(this.localAndOtherTaxes) !== 0) results.push({ 'description': 'Local/Other  Taxes', 'amount': this.localAndOtherTaxes })
    if (this.postageDelivery && parseFloat(this.postageDelivery) !== 0) results.push({ 'description': 'Postage & Delivery', 'amount': this.postageDelivery })
    if (this.erReturnedDeductions && parseFloat(this.erReturnedDeductions) !== 0) results.push({ 'description': 'Returned for Employee Benefits', 'amount': this.erReturnedDeductions })
    return results
  }

  async generateCustomTimeEntryData () {
    let results = []

    // Load all employees in this payroll
    await EmployeeResource.all({ query: { id__in: this.employeeIds.join(',') } })
    await AssignmentResource.all({ query: { id__in: this.assignmentIds.join(',') } })

    // Get DD and addresses in one big chunk
    await EmployeeDirectDepositRuleResource.all({ query: { employee__in: this.employeeIds.join(',') } })
    // await DepositAccountResource.all({ query: { employee__in: this.employeeIds.join(',') } })

    const empResources = EmployeeResource.getCachedAll() || []
    const addressResidenceIds = [ ...new Set(empResources.map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.address_residence : null)) ]
    if (addressResidenceIds) {
      // await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') }, resolveRelated: { managers: [ 'state', 'city' ] } })
      await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') } })
      const cityIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.city : null)) ]
      const stateIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.state : null)) ]
      if (cityIds) {
        await CityResource.all({ query: { id__in: cityIds.join(',') } })
      }
      if (stateIds) {
        await StateResource.all({ query: { id__in: stateIds.join(',') } })
      }
    }

    let sorted = sortObjectByProperty(this.assignmentsData, 'employeeName')

    for (const i in sorted) {
      const data = sorted[i]
      const pay = data.getLinesByPayCode('getTotalPayLines')
      let budgetDetails = []

      const empResource = ((EmployeeResource.getCached(data.employeeId) || {}).resource || {})
      const eeAddressId = empResource.attributes.address_residence
      const eeAddress = eeAddressId && AddressResource.getCached(eeAddressId) ? AddressResource.getCached(eeAddressId).resource : new AddressResource()
      const eeDirectDeposit = (EmployeeDirectDepositRuleResource.getCachedAll() || []).find((cached) =>
        cached && cached.resource.attributes && cached.resource.attributes.employee === data.employeeId && cached.resource.attributes.active === true
      )
      await eeAddress.resolveRelated({ managers: [ 'state', 'city' ] })

      for (const accountString in pay) {
        const payData = pay[accountString]
        const payLines = payData.breakdown.wages.total.lines
        let budgetDetail = {
          work_state: payData.workState,
          pension_hours: payData.getPensionableHours(),
          occ_codes: [
            payData.jobTitle
          ],
          taxable: payLines[0].taxable,
          gross_wages: payData.getTotalPay(),
          contract_occ_codes: [],
          hours: payData.getTotalHours(),
          // contract_occ_codes: [],
          // wc_classification: "CR - Crew ",
          hourly_unit_rate: payLines[0].hourly_unit_rate,
          pay_code: payLines[0].code + ' - ' + payLines[0].code_name,
          budget_string: accountString.replace(/|/g, '-'),
          pay_lines: payLines.map((line) => {
            line.customer_budget_code = line.customer_budget_code || data.defaultBudgetCode
            line.customer_fringe_code = line.customer_fringe_code || data.defaultFringeCode
            line.customer_hf_code = line.customer_hf_code || data.defaultHandlingCode || data.defaultFringeCode
            line.gross_wages = line.amount_decimal
            line.occ_code = '0 - ' + payData.jobTitle
            line.state_zip = payData.workState + ' ' + payData.workCity
            line.wc_classification = ''
            line.budget_string = line.customer_budget_code + '-' + line.customer_fringe_code
            if (line.customer_hf_code) line.budget_string += '-' + line.customer_hf_code
            if (line.customer_series) line.budget_string += '-' + line.customer_series
            if (line.customer_location) line.budget_string += '-' + line.customer_location
            if (line.customer_set) line.budget_string += '-' + line.customer_set
            if (line.customer_ff1) line.budget_string += '-' + line.customer_ff1
            if (line.customer_ff2) line.budget_string += '-' + line.customer_ff2
            line.work_date = payData.payPeriodEndDate
            line.pay_code = line.code + ' ' + line.code_name
            return line
          })
        }

        budgetDetails.push(budgetDetail)
      }

      let assignmentDetail = {
        payroll: this.payrollId,
        payroll_invoice_number: this.payrollNumber,
        check_date: this.checkDate,
        // direct_deposit: 'N' if assignment.payment_method != Employee.EMP_PAYMENT_TYPE_DIRECT_DEPOSIT else 'Y',
        union: data.localName + ' No ' + data.local,
        employee: data.employeeName,
        loanout_name: data.loanoutName,
        // employee_id: employee.id,
        employee_ssn: '*****' + data.tinLast4,
        employee_fein: data.feinLast4 ? '*****' + data.feinLast4 : null,
        employee_address1: eeAddress.attributes.line1,
        employee_address2: eeAddress.attributes.line2,
        employee_postal: eeAddress.attributes.postal,
        employee_city: eeAddress.get('city.name'),
        employee_state: eeAddress.get('state.code'),
        direct_deposit: eeDirectDeposit ? 'Y' : 'N',
        // employee_phone: safe_nested_getattr(employee, 'address_residence.contact_phone', default='', coalesce=True),
        occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        contract_occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        work_days: data.getWorkDays(),
        hours: data.getTotalHours(),
        pension_hours: data.getPensionableHours(),
        gross_wages: data.getTotalPay(),
        benefits_total: data.getErBenefitFees(),
        deductions_total: data.getEeTotalDeductions(),
        withholding_total: data.getEeTotalWithholding(),
        withholding_status: [],
        // withholding_status: employee.get_w4_items_for_paycheck_json(payroll, jasper_friendly=True),

        detail: {
          gross_wages: data.getTotalPay(),
          hours: data.getTotalHours(),
          pension_hours: data.getPensionableHours(),
          budget_string: '',
          budget_detail: budgetDetails
        }
      }

      results.push(assignmentDetail)
    }

    return results
  }

  generateDetailPayEdit () {
    let result = []
    let sorted = sortObjectByProperty(this.assignmentsData, 'employeeName')

    for (const i in sorted) {
      const data = sorted[i]
      const payLines = sortObjectByProperty(data.breakdown.wages.total.lines, 'code')
      const groupedDeductionLines = groupByProperty(sortObjectByProperty(data.breakdown.eeDeductions.total.lines, 'code'), 'pay_fee_id')
      let deductionLines = []
      for (const i in groupedDeductionLines) {
        const group = groupedDeductionLines[i]
        const result = {
          code_name: group[0].code_name,
          amount_decimal: group.reduce((prev, curr) => prev + parseFloat(curr.amount_decimal), 0),
          subject_wages: group.reduce((prev, curr) => prev + parseFloat(curr.subject_wages), 0)
        }
        deductionLines.push(result)
      }
      const groupedBenefitLines = groupByProperty(sortObjectByProperty(data.breakdown.erFees.er_ben.lines, 'code'), 'pay_fee_id')
      let benefitLines = []
      for (const i in groupedBenefitLines) {
        const group = groupedBenefitLines[i]
        const result = {
          code_name: group[0].code_name,
          amount_decimal: group.reduce((prev, curr) => prev + parseFloat(curr.amount_decimal), 0),
          subject_wages: group.reduce((prev, curr) => prev + parseFloat(curr.subject_wages), 0)
        }
        benefitLines.push(result)
      }
      let assignmentDetail = {
        last_name: data.lastName,
        first_name: data.firstName,
        tin: '*****' + data.tinLast4,
        loanout_name: data.loanoutName,
        employee_name_report: data.isLoanout ? data.loanoutName : data.employeeName,
        fein: data.feinLast4 ? '*****' + data.feinLast4 : null,
        job_title_overrides: [
          data.getJobTitle()
        ],
        /*
        occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        contract_occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        */
        assignment_occ_codes: [
          ' - ' + data.getJobTitle()
        ],

        work_days: data.getWorkDays(),
        gross_total: data.getTotalPay(),
        hours_total: data.getTotalHours(),
        benefits_total: data.getErBenefitFees(),
        deductions_total: data.getEeTotalDeductions(),
        withholding_total: data.getEeTotalTaxes(),
        cost_total: data.totalAmount,
        wages: payLines.map((line) => {
          line.job = (line.customer_budget_code || data.defaultBudgetCode || '') + '-' + (line.customer_fringe_code || data.defaultFringeCode || '')
          if (line.customer_series) line.job += '-' + line.customer_series
          if (line.customer_location) line.job += '-' + line.customer_location
          if (line.customer_set) line.job += '-' + line.customer_set
          if (line.customer_ff1) line.job += '-' + line.customer_ff1
          if (line.customer_ff2) line.job += '-' + line.customer_ff2
          line.wages = line.amount_decimal
          line.pay_code = line.code
          line.description = line.code_name
          return line
        }),
        deductions: deductionLines.map((line) => {
          line.amount = line.amount_decimal
          line.name = line.code_name
          return line
        }),
        benefits: benefitLines.map((line) => {
          line.amount = line.amount_decimal
          line.name = line.code_name
          line.subject_wages = line.subject_wages
          return line
        }),
        withholding: {
          total: data.getEeTotalWithholding(),
          fica_ss: data.getEeFica(),
          fica_medi: data.getEeMedc(),
          fit: data.getEeFit(),
          sit: data.getEeSit(),
          sdi: data.getEeSdi(),
          local: data.getEeLocal(),
          other: []
        },
        er_costs: {
          total_cost: data.totalAmount,
          total_fringe: data.getTotalErCost(),
          taxable_wages: data.getTaxablePay(),
          non_taxable_wages: data.getNonTaxablePay(),
          admin: data.getHandlingAndAcaFees(),
          wc: data.getWcFees(),
          suta: data.getErSuta(),
          er_benefits: data.getErBenefitFees(),
          fica: data.getErFica(),
          futa: data.getErFuta(),
          er_local: (parseFloat(data.getErLocalTaxFees()) + parseFloat(data.getErLocalTax())).toFixed(2),
          inv_adjs: data.getErInvAdj(),
          postage: data.getPostageDelivery(),
          returned_deductions: data.getErReturnedDeductions()
        }
      }

      // Add details for withholding
      for (const i in data.breakdown.eeTaxes.ee_local.lines) {
        let line = data.breakdown.eeTaxes.ee_local.lines[i]
        if (!line) continue
        let other = {
          name: line.code_name,
          amount: line.amount_decimal
        }
        assignmentDetail.withholding.other.push(other)
      }

      // Add details for wages
      for (const i in data.breakdown.eeTaxes.business_tax.lines) {
        let line = data.breakdown.eeTaxes.business_tax.lines[i]
        if (!line) continue
        let other = {
          name: line.code_name,
          amount: line.amount_decimal
        }
        assignmentDetail.withholding.other.push(other)
      }
      let wageDetail = data.getDataByPayCode('getTotalPay')
      // let wageDetail = data.getDataByCoding('getTotalPay')
      // console.log(wageDetail)
      for (const i in wageDetail.lines) {
        const line = wageDetail.lines[i]
        let detail = {
          hours: line.hours,
          job: (line.customer_budget_code || data.defaultBudgetCode || '') + '-' + (line.customer_fringe_code || data.defaultFringeCode || ''),
          wages: line.amount_decimal,
          description: line.description_report,
          pay_code: line.code
        }
        if (detail.customer_series) detail.job += '-' + line.customer_series
        if (detail.customer_location) detail.job += '-' + line.customer_location
        if (detail.customer_set) detail.job += '-' + line.customer_set
        if (detail.customer_ff1) detail.job += '-' + line.customer_ff1
        if (detail.customer_ff2) detail.job += '-' + line.customer_ff2

        assignmentDetail.wages.push(detail)
        assignmentDetail.wages.push(detail)
      }

      result.push(assignmentDetail)
    }

    // console.log(result)
    return result
  }

  generateFringeRecapData () {
    let results = []
    let sorted = sortObjectByProperty(this.assignmentsData, 'employeeName')

    for (const i in sorted) {
      const data = sorted[i]
      let assignmentDetail = {
        first_name: data.lastName, // flipped because wrong in template
        last_name: data.firstName, // flipped because wrong in template
        loanout_name: data.loanoutName,
        employee_name_report: data.isLoanout ? data.loanoutName : data.employeeName,
        tin: '*****' + data.tinLast4,
        fein: data.feinLast4 ? '*****' + data.feinLast4 : null,

        total_cost: data.totalAmount,
        total_fringe: data.getTotalErCost(),
        taxable_wages: data.getTaxablePay(),
        non_taxable_wages: data.getNonTaxablePay(),
        admin_fees: data.getHandlingAndAcaFees(),
        wc_fees: data.getWcFees(),
        union_benefit_fees: data.getErBenefitFees(),
        fica_fees: data.getErFica(),
        futa_fees: data.getErFuta(),
        suta_fees: data.getErSuta(),
        local_taxes: (parseFloat(data.getErLocalTaxFees()) + parseFloat(data.getErLocalTax())).toFixed(2),
        other_payroll_tax_fees: (parseFloat(data.getPostageDelivery()) + parseFloat(data.getErBusinessTax()) + parseFloat(data.getErSalesTax())).toFixed(2),
        credit_to_client_deductions: data.getErReturnedDeductions(),
        vacation_holiday: '0.00',
        checks: [
          {
            total_cost: data.totalAmount,
            total_fringe: data.getTotalErCost(),
            taxable_wages: data.getTaxablePay(),
            non_taxable_wages: data.getNonTaxablePay(),
            admin_fees: data.getHandlingAndAcaFees(),
            wc_fees: data.getWcFees(),
            union_benefit_fees: data.getErBenefitFees(),
            fica_fees: data.getErFica(),
            futa_fees: data.getErFuta(),
            suta_fees: data.getErSuta(),
            local_taxes: (parseFloat(data.getErLocalTaxFees()) + parseFloat(data.getErLocalTax())).toFixed(2),
            other_payroll_tax_fees: (parseFloat(data.getPostageDelivery()) + parseFloat(data.getErBusinessTax()) + parseFloat(data.getErSalesTax())).toFixed(2),
            credit_to_client_deductions: data.getErReturnedDeductions(),
            vacation_holiday: '0.00',
            // payroll: ,
            check_number: data.paymentNumbers
          }
        ]
      }

      results.push(assignmentDetail)
    }

    return results
  }

  async generateWageCheckRegisterData () {
    let sorted = sortObjectByProperty(this.assignmentsData, 'employeeName')
    let results = {
      data: [],
      payCodeTotals: [],
      taxTotals: [],
      deductionTotals: []
    }

    // Total up pay, tax, and deductions here
    let payCodeTotals = {}
    let taxTotals = {}
    let deductionTotals = {}

    // Load all employees in this payroll
    await EmployeeResource.all({ query: { id__in: this.employeeIds.join(',') } })
    await AssignmentResource.all({ query: { id__in: this.assignmentIds.join(',') } })

    const empResources = EmployeeResource.getCachedAll() || []
    const addressResidenceIds = [ ...new Set(empResources.map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.address_residence : null)) ]
    if (addressResidenceIds) {
      // await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') }, resolveRelated: { managers: [ 'state', 'city' ] } })
      await AddressResource.all({ query: { id__in: addressResidenceIds.join(',') } })
      const cityIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.city : null)) ]
      const stateIds = [ ...new Set((AddressResource.getCachedAll() || []).map((cached) => (cached && cached.resource.attributes) ? cached.resource.attributes.state : null)) ]
      if (cityIds) {
        await CityResource.all({ query: { id__in: cityIds.join(',') } })
      }
      if (stateIds) {
        await StateResource.all({ query: { id__in: stateIds.join(',') } })
      }
    }

    // Loop throught assignments
    for (const i in sorted) {
      const data = sorted[i]
      const empResource = ((EmployeeResource.getCached(data.employeeId) || {}).resource || {})
      const eeAddressId = empResource.attributes.address_residence
      const eeAddress = eeAddressId && AddressResource.getCached(eeAddressId) ? AddressResource.getCached(eeAddressId).resource : new AddressResource()
      /*
      const eeDirectDeposit = (EmployeeDirectDepositRuleResource.getCachedAll() || []).find((cached) =>
        cached && cached.resource.attributes && cached.resource.attributes.employee === data.employeeId && cached.resource.attributes.active === true
      )
      */
      await eeAddress.resolveRelated({ managers: [ 'state', 'city' ] })

      // const payLines = data.breakdown.wages.total.lines
      let payLines = []
      let withholdingLines = []
      let deductionLines = []
      let benefitLines = []
      const linesByPayCode = data.getLinesByPayCode()
      for (const payCode in linesByPayCode) {
        let data = linesByPayCode[payCode]
        let result = {
          code: payCode,
          name: data.lines[0].code_name,
          pay_code: payCode + '-' + data.lines[0].code_name,
          amount: data.getTotalPay(),
          hours_units: data.getTotalHours(),
          hourly_unit_rate: data.lines[0].hourly_unit_rate,
          occ_code_description: data.lines[0].job_title,
          hourly_pay_rate: data.lines[0].hourly_pay_rate,
          pay_rate: data.lines[0].pay_rate,
          // pay_rate_unit: 'HOURLY',
          // occ_code: 176,
          // pay_frequency: 'WEEKLY',
          // contract_occ_code: 'None',
          ytd_pension_hours_units: (this.employeeYTD[data.employeeId].all || {}).PAY[payCode].pension_hours_units,
          ytd_amount_decimal: (this.employeeYTD[data.employeeId].all || {}).PAY[payCode].amount_decimal,
          ytd_hours_units: (this.employeeYTD[data.employeeId].all || {}).PAY[payCode].hours,
          work_state: data.workState
        }

        // console.log(result)
        payLines.push(result)

        // Add to total
        if (typeof payCodeTotals[data.workState] === 'undefined') {
          payCodeTotals[data.workState] = {
            state: data.workState,
            total: 0,
            payCodeDetail: {}
          }
        }
        payCodeTotals[data.workState].total += parseFloat(data.getTotalPay())
        if (typeof payCodeTotals[data.workState].payCodeDetail[payCode] === 'undefined') {
          payCodeTotals[data.workState].payCodeDetail[payCode] = {
            pay_code: payCode + '-' + data.lines[0].code_name,
            amount: 0,
            hours_units: 0
          }
        }

        payCodeTotals[data.workState].payCodeDetail[payCode].amount += parseFloat(data.getTotalPay())
        payCodeTotals[data.workState].payCodeDetail[payCode].hours_units += parseFloat(data.getTotalHours())
      }

      const linesByEeTaxCode = data.getLinesByPayCode('getTotalEeTaxLines')
      for (const feeCode in linesByEeTaxCode) {
        let data = linesByEeTaxCode[feeCode]
        let result = {
          code: feeCode,
          name: data.lines[0].code_name,
          pay_code: data.lines[0].code_name,
          amount_decimal: data.getEeTotalTaxes(),
          ytd_hours_units: null,
          ytd_pension_hours_units: null,
          ytd_amount_decimal: (this.employeeYTD[data.employeeId].all || {}).EETAX[feeCode].amount_decimal
        }
        withholdingLines.push(result)

        // Add to total
        if (typeof taxTotals[feeCode] === 'undefined') {
          taxTotals[feeCode] = {
            deduction: data.lines[0].code_name,
            amount: 0,
            ytd_amount: null
          }
        }

        taxTotals[feeCode].amount += parseFloat(data.getEeTotalTaxes())
      }

      const linesByDeductionCode = data.getLinesByPayCode('getTotalDeductionLines')
      for (const feeCode in linesByDeductionCode) {
        let data = linesByDeductionCode[feeCode]
        let result = {
          code: feeCode,
          name: data.lines[0].code_name,
          pay_code: data.lines[0].code_name,
          amount_decimal: data.getEeTotalDeductions(),
          ytd_hours_units: null,
          ytd_pension_hours_units: null,
          ytd_amount_decimal: (this.employeeYTD[data.employeeId].all || {}).DEDUCTION[feeCode].amount_decimal
        }
        deductionLines.push(result)

        // Add to total
        if (typeof deductionTotals[feeCode] === 'undefined') {
          deductionTotals[feeCode] = {
            deduction: data.lines[0].code_name,
            amount: 0,
            ytd_amount: null
          }
        }

        deductionTotals[feeCode].amount += parseFloat(data.getEeTotalDeductions())
      }

      const linesByBenefitCode = data.getLinesByPayCode('getTotalUnionBenefitLines')
      for (const feeCode in linesByBenefitCode) {
        let data = linesByBenefitCode[feeCode]
        let result = {
          code: feeCode,
          name: data.lines[0].code_name,
          pay_code: data.lines[0].code_name,
          amount_decimal: data.getTotalUnionBenefits(),
          ytd_hours_units: null,
          ytd_pension_hours_units: null,
          ytd_amount_decimal: (this.employeeYTD[data.employeeId].all || {}).ERFEE[feeCode].amount_decimal
        }
        benefitLines.push(result)
      }

      let assignmentDetail = {
        employee: data.lastName + ', ' + data.firstName,
        employee_ssn: '*****' + data.tinLast4,
        loanout_name: data.loanoutName,
        employee_fein: data.feinLast4 ? '*****' + data.feinLast4 : null,
        employee_name_report: data.isLoanout ? data.loanoutName : data.employeeName,
        employee_address1: eeAddress.attributes.line1,
        employee_address2: eeAddress.attributes.line2,
        employee_postal: eeAddress.attributes.postal,
        employee_city: eeAddress.get('city.name'),
        employee_state: eeAddress.get('state.code'),
        // agent: data.agent || '',
        job_title_overrides: [
          data.getJobTitle()
        ],
        /*
        occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        contract_occ_codes: [
          ' - ' + data.getJobTitle()
        ],
        */
        assignment_occ_codes: [
          ' - ' + data.getJobTitle()
        ],

        work_days: data.getWorkDays(),
        gross_wages: data.getTotalPay(),
        ytd_gross_wages: (((this.employeeYTD[data.employeeId].all || {}).PAY || {}).total || {}).amount_decimal,
        er_billed_benefits: data.getErBenefitFees(),
        er_billed_benefits_ytd: (((this.employeeYTD[data.employeeId].all || {}).ERFEE || {}).total || {}).amount_decimal,
        deductions: data.getEeTotalDeductions(),
        deductions_ytd: (((this.employeeYTD[data.employeeId].all || {}).DEDUCTION || {}).total || {}).amount_decimal,
        withholding: data.getEeTotalTaxes(),
        withholding_ytd: (((this.employeeYTD[data.employeeId].all || {}).EETAX || {}).total || {}).amount_decimal,
        hours: data.getTotalHours(),
        ytd_hours: (((this.employeeYTD[data.employeeId].all || {}).PAY || {}).total || {}).hours,
        cost_total: data.totalAmount,
        pay_code_detail: payLines,
        deduction_detail: deductionLines,
        withholding_detail: withholdingLines,
        er_billed_benefits_total: benefitLines,
        er_costs: {
          total_cost: data.totalAmount,
          total_fringe: data.getTotalErCost(),
          taxable_wages: data.getTaxablePay(),
          non_taxable_wages: data.getNonTaxablePay(),
          admin: data.getHandlingAndAcaFees(),
          wc: data.getWcFees(),
          suta: data.getErSuta(),
          er_benefits: data.getErBenefitFees(),
          fica: data.getErFica(),
          futa: data.getErFuta(),
          er_local: (parseFloat(data.getErLocalTaxFees()) + parseFloat(data.getErLocalTax())).toFixed(2),
          inv_adjs: data.getErInvAdj(),
          postage: data.getPostageDelivery(),
          returned_deductions: data.getErReturnedDeductions()
        }
      }

      results.data.push(assignmentDetail)
    }

    // Totals for payroll
    for (const i in payCodeTotals) {
      // convert our object into an array
      let subTotal = payCodeTotals[i]
      subTotal.pay_code_detail = []
      for (const j in subTotal.payCodeDetail) {
        subTotal.pay_code_detail.push(subTotal.payCodeDetail[j])
      }
      results.payCodeTotals.push(subTotal)
    }

    // Add details for withholding
    for (const i in taxTotals) {
      results.taxTotals.push(taxTotals[i])
    }

    // Add details for deductions
    for (const i in deductionTotals) {
      results.deductionTotals.push(deductionTotals[i])
    }

    return results
  }

  /**
   * Loads all data
   */
  async loadData () {
  }

  /**
   * Takes an array containing arrays of requests and flattens it
   * @param requestArrays
   */
  flattenRequestArrays (requestArrays) {
    let allRequests = []
    requestArrays.forEach(v => {
      if (v.length) {
        allRequests = [...allRequests, ...v]
      }
    })
    return allRequests
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/PayrollData.js